import { render, staticRenderFns } from "./CaiwuLayout.vue?vue&type=template&id=0253e96f&scoped=true&"
import script from "./CaiwuLayout.vue?vue&type=script&lang=js&"
export * from "./CaiwuLayout.vue?vue&type=script&lang=js&"
import style0 from "./CaiwuLayout.vue?vue&type=style&index=0&id=0253e96f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253e96f",
  null
  
)

export default component.exports